import React, { type MouseEvent } from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button';
import InlineMessage from '@atlaskit/inline-message';
import { token } from '@atlaskit/tokens';
import type { AnalyticsEvent } from '@atlassian/jira-common-analytics-v2-wrapped-components/src/types.tsx';
import type { IntlShapeV2 as Intl } from '@atlassian/jira-intl/src/v2/types.tsx';
import messages from './messages.tsx';
import { InlineMessageHeading } from './styled.tsx';

export const renderInlineMessage = (
	intl: Intl,
	headerMessage: string,
	contentMessage: string | string[],
	onRetryClick: (arg1: MouseEvent<HTMLElement>, arg2: AnalyticsEvent) => void,
	onCancelClick: () => void,
	userHasPermissionToLink?: Boolean,
) => {
	const RetryButtonNew = userHasPermissionToLink ? (
		<InlineMessageRightButtonPadding>
			<Button
				onClick={onRetryClick}
				interactionName="auto-generated.jira-issue-view-common-views.issue-line-card.view.inline-message.button1"
			>
				{intl.formatMessage(messages.retry)}
			</Button>
		</InlineMessageRightButtonPadding>
	) : null;
	const cancelButtonNew = (
		<Button
			appearance="subtle"
			onClick={onCancelClick}
			interactionName="auto-generated.jira-issue-view-common-views.issue-line-card.view.inline-message.button3"
		>
			{intl.formatMessage(messages.cancel)}
		</Button>
	);

	return (
		<InlineMessage appearance="warning" placement="bottom-end">
			<div>
				<InlineMessageHeading>{headerMessage}</InlineMessageHeading>
				{Array.isArray(contentMessage) ? (
					contentMessage.map((message, idx) => (
						<InlineMessageText key={idx}>{message}</InlineMessageText>
					))
				) : (
					<InlineMessageText>{contentMessage}</InlineMessageText>
				)}
				<InlineMessageButtonsWrapper>
					{RetryButtonNew}
					{cancelButtonNew}
				</InlineMessageButtonsWrapper>
			</div>
		</InlineMessage>
	);
};

// eslint-disable-next-line @atlaskit/design-system/use-primitives, @atlaskit/ui-styling-standard/no-styled
const InlineMessageRightButtonPadding = styled.div({
	marginRight: token('space.100', '8px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const InlineMessageButtonsWrapper = styled.div({
	display: 'flex',
	justifyContent: 'flex-start',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const InlineMessageText = styled.div({
	marginBottom: token('space.200', '16px'),
});
